<template>
  <div class="xh-wrap">
    <!-- <page-top></page-top> -->
    <myImg img="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner2.jpg"></myImg>
    <myTab
      :tab-list="tabList"
      @change="changeTab"
      :activeIndex="activeIndex"
      :bread-title="breadTitle"
      smallSize
    ></myTab>
    <template v-if="activeIndex == 0">
      <div class="container text-center color-ccc fs-30 empty-tip ">
        敬请期待
      </div>
    </template>
    <template v-if="activeIndex == 1">
      <div class="container text-center color-ccc  fs-30 empty-tip ">
        敬请期待
      </div>
    </template>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
import pageFooter from "@/components/pageFooter";
import myImg from "@/components/myImg";
import myTab from "@/components/myTab";
export default {
  components: {
    pageTop,
    pageFooter,
    myImg,
    myTab,
  },
  data() {
    return {
      tabList: [
        {
        title:"新闻发布会",
        en:"Press Conference"
      },
      {
        title:"同期活动",
        en:"Meetings&"
      }
    ],
      activeIndex: 0,
      breadTitle: {
        cn: "活动",
        en: "Activities",
      }
    };
  },
  watch: {},
  methods: {
    changeTab(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 100px) and (max-width: 1000px) {
  .empty-tip {
    padding: 300px 0;
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  .empty-tip {
    padding: 200px 0;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?646e0d32